import axios from "axios";

export interface NonVotingCoach {
  name: string;
  number: string;
  email: string;
  team: string;
  lastVoteDate: string | null;
  daysSinceLastVote: number | null;
  hasNeverVoted: boolean;
}

export interface NonVotersAnalytics {
  weekendDate: string;
  matchCount: number;
  totalCoaches: number;
  coachesWhoDidntVote: number;
  coaches: NonVotingCoach[];
}

export interface NonVotersResponse {
  status: string;
  message: string;
  data: NonVotersAnalytics;
}

export const analyticsApi = {
  getNonVoters: async (): Promise<NonVotersAnalytics> => {
    const token = localStorage.getItem("token");
    const response = await axios.get<NonVotersResponse>(
      "/api/coaches/analytics/non-voters",
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data.data;
  },
};
